import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f3afec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-doubts-list" }
const _hoisted_2 = ["data-doubt"]
const _hoisted_3 = {
  key: 0,
  class: "answer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentComment = _resolveComponent("ContentComment")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentDoubts, (doubt, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        "data-doubt": `${doubt.id}`
      }, [
        _createVNode(_component_ContentComment, {
          title: doubt.title,
          comment: doubt.description,
          date: doubt.createdAt,
          "user-name": doubt.userName,
          "user-image": doubt.userImage,
          "user-i-d": index
        }, null, 8, ["title", "comment", "date", "user-name", "user-image", "user-i-d"]),
        (doubt.answer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_ContentComment, {
                comment: doubt.answer.description,
                date: doubt.answer.createdAt,
                "user-name": doubt.answer.userName,
                "user-image": doubt.answer.userImage,
                "user-i-d": index
              }, null, 8, ["comment", "date", "user-name", "user-image", "user-i-d"])
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}